import * as React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

export const formatMoney = (value: any) => {
  const n = Number(value || 0);
  return new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatPercent = (value: any) => {
  const n = Number(value || 0);
  return `${new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: 2,
  }).format(n)}%`;
};

export const isMissingGridValue = (row: any, field: string) =>
  row?.missing?.includes(field) ||
  row?.[field] === null ||
  row?.[field] === undefined ||
  row?.[field] === '';

export const FGridMissingCell = (params: GridRenderCellParams) => {
  const bad = isMissingGridValue(params.row, params.field);

  if (!bad) return <span>{params.value}</span>;

  return (
    <Tooltip title={`${params.field} is mandatory`}>
      <Chip size="small" label="Missing" color="error" />
    </Tooltip>
  );
};

export const FGridMoneyCell = (params: GridRenderCellParams) => (
  <Box sx={{ width: '100%', textAlign: 'right' }}>
    {formatMoney(params.value || 0)}
  </Box>
);

export const FGridPercentCell = (params: GridRenderCellParams) => (
  <Box sx={{ width: '100%', textAlign: 'right' }}>
    {formatPercent(params.value || 0)}
  </Box>
);

export const FGridStatusChip = (params: GridRenderCellParams) => {
  const value = String(params.value || '');
  const up = value.toUpperCase();

  let color: any = 'default';
  if (up.includes('APPRO') || up.includes('VALID') || up.includes('COMPLETE')) color = 'success';
  else if (up.includes('PLAN') || up.includes('DRAFT') || up.includes('NOUV')) color = 'info';
  else if (up.includes('REJECT') || up.includes('ABAND') || up.includes('ERROR')) color = 'error';
  else if (up.includes('PEND') || up.includes('WAIT')) color = 'warning';

  return <Chip size="small" label={value || '—'} color={color} />;
};
